import React from 'react';
import GameCare from "../../../assets/images/bottomFooter/gamecare.svg";
import BeGambleAware from "../../../assets/images/bottomFooter/gambleaware.png";
import GamStop from "../../../assets/images/bottomFooter/gamestop.svg";
import EighteenPlus from "../../../assets/images/bottomFooter/18plus (1).png";

const FooterSection = () => {
  return (
    <div className="w-full fixed bottom-0">
      {/* Top Section - Responsible Gambling */}
      <div style={{
        backgroundImage: "linear-gradient(rgb(111, 111, 111), rgb(15, 15, 15))",
      }} className="px-2 py-2">
        <div className="flex flex-wrap items-center justify-center gap-1 text-white text-[14px]">
          <span className="whitespace-nowrap">Responsible Gambling</span>
          <span className="text-white">|</span>
          <span className="whitespace-nowrap">Prohibited Territories</span>
          <span className="text-white">|</span>

          <img
            src={GameCare}
            className="w-[80px] h-[23px] object-contain invert brightness-0 hue-rotate-180deg"
            alt="GameCare"
          />
          <span className="text-gray-300">|</span>
          <img
            src={BeGambleAware}
            className="w-[115px] game-care h-[12px] object-contain flex items-center justify-center filter invert brightness-200"
            alt="BeGambleAware"
          />
          <span className="text-gray-300">|</span>

          {/* GAMSTOP Badge */}
          <div className="flex items-center">
            <img
              src={GamStop}
              className="w-[90px] h-[16px] object-contain flex items-center justify-center"
              alt="GamStop"
            />
          </div>

          <span className="text-gray-300">|</span>

          {/* 18+ Badge */}
          <img
            src={EighteenPlus}
            className="w-[30px] h-[30px] object-contain flex items-center justify-center"
            alt="18+"
          />
        </div>
        {/* Bottom Section - Copyright */}
        <div className="px-2 py-1">
          <div className="text-center text-white text-[14px]">
            Rules & Regulations © 2016-2020 Powered By
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;

